module.exports = __webpack_public_path__ + "static/media/ic-info-bobtv.0ccd97cb.svg";